module.exports = __webpack_public_path__ + "static/media/5-pin.46cd7efb.svg";